import { useAuth } from '../contexts/AuthContext';
import { getAvatarUrl } from '../utils/avatarUtils';

function AppMiniHeader() {
    const { user } = useAuth();
    const fullName = [user?.firstName, user?.lastName].filter(Boolean).join(' ') || 'دانش آموز';

    return (
        <header className="w-11/12 mx-auto py-4 mt-4">
            <div
                className='w-full h-[80px] rounded-[10px] p-3 flex flex-col justify-between'
                style={{ background: 'linear-gradient(20.43deg, rgba(84, 176, 248, 0.7) 0.9%, rgba(145, 73, 133, 0.7) 86.43%)', boxShadow: '4px 5px 11px rgba(0, 0, 0, 0.14)' }}
            >
                <div className="w-full flex items-center justify-between">
                    <div className='grid grid-cols-1 gap-2'>
                        <div className='flex items-center gap-2 justify-start'>
                            <p className='font-light text-[13px] text-white'>
                                نام:
                            </p>

                            <p className='text-[13px] text-white'>
                                {fullName}
                            </p>
                        </div>

                        <div className='flex items-center gap-2 justify-start'>
                            <p className='font-light text-[13px] text-white'>
                                پایه:
                            </p>

                            <p className='text-[13px] text-white'>
                                {user?.grade?.title || 'نامشخص'}
                            </p>
                        </div>
                    </div>

                    <div className='w-[90px] h-[90px] rounded-full overflow-hidden border-[3px] border-[#E0E0E0] -mt-[30px]'>
                        <img className='object-cover w-[90px] h-[90px]' src={getAvatarUrl(user?.avatar)} alt="" />
                    </div>
                </div>
            </div>
        </header>
    );
}

export default AppMiniHeader;
